module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-7.1b9cde11.jpg";